import React, { forwardRef, useState } from "react";
// import "./FindMember.css";
// import "../../components/CommonStyle.css";
import CalendarImg from "../../Images/calendar.png";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import FMSelectMultipleOptionItems from "./FMSelectMultipleOptionItems";
import {
  updateSearchParamFlags,
  resetSearchParamFlags,
} from "../../store/hasSearchParamFlags";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import { updateMember_Tags } from "../../store/memberApiSlice";
import { updateSearchBody } from "../../store/searchMemberApiSlice";
interface Tag {
  [key: string]: any;
}

interface IProps {
  Tags: Tag[];
}

const FMMemberTags: React.FC<IProps> = (props) => {
  const Tags = props.Tags;
  const dispatch = useDispatch();
  const [SelectedInTags, setSelectedInTags] = useState<number[]>([]);
  const [SelectedNotInTags, setSelectedNotInTags] = useState<number[]>([]);

  const [SelectedInTagsArray, setSelectedInTagsArray] = useState<string[]>([]);
  const [SelectedNotInTagsArray, setSelectedNotInTagsArray] = useState<
    string[]
  >([]);
  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    inFlag: boolean
  ) => {
    console.log("checked..", event.target.value, "-", inFlag);
    let inTags: number[] = [];
    let notInTags: number[] = [];
    let inTagArray: string[] = [];
    let notInTagsArray: string[] = [];
    inTags.push(...SelectedInTags);
    notInTags.push(...SelectedNotInTags);
    inTagArray.push(...SelectedInTagsArray);
    notInTagsArray.push(...SelectedNotInTagsArray);
    if (inFlag === true) {
      console.log(event.target.name);
      //add in list
      setSelectedInTagsArray((selectedItems) => [
        ...SelectedInTagsArray,
        event.target.name,
      ]);
      inTagArray.push(event.target.name);

      //add in list
      setSelectedInTags((selectedItems) => [
        ...SelectedInTags,
        Number(event.target.id),
      ]);
      inTags.push(Number(event.target.id));

      //remove from not in list
      setSelectedNotInTagsArray((selectedItems) =>
        SelectedNotInTagsArray.filter((item) => {
          return item !== event.target.name;
        })
      );
      notInTagsArray = notInTagsArray.filter(function (item) {
        return item !== event.target.name;
      });
      // remove from not in list
      console.log("un checked");
      setSelectedNotInTags((selectedItems) =>
        SelectedNotInTags.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      notInTags = notInTags.filter(function (item) {
        return item !== Number(event.target.id);
      });
      dispatch(
        updateSearchParamFlags({ key: "HasInTagsSearchParam", value: true })
      );
    } else {
      console.log(event.target.name);
      //add in not in list
      setSelectedNotInTagsArray((selectedItems) => [
        ...SelectedNotInTagsArray,
        event.target.name,
      ]);
      notInTagsArray.push(event.target.name);

      //add in not in list
      setSelectedNotInTags((selectedItems) => [
        ...SelectedNotInTags,
        Number(event.target.id),
      ]);
      notInTags.push(Number(event.target.id));

      //remove from in list
      setSelectedInTagsArray((selectedItems) =>
        SelectedInTagsArray.filter((item) => {
          return item !== event.target.name;
        })
      );
      inTagArray = inTagArray.filter(function (item) {
        return item !== event.target.name;
      });

      // remove from in list
      console.log("un checked");
      setSelectedInTags((selectedItems) =>
        SelectedInTags.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      inTags = inTags.filter(function (item) {
        return item !== Number(event.target.id);
      });

      dispatch(
        updateSearchParamFlags({ key: "HasNotInTagsSearchParam", value: true })
      );
    }
    console.log("selectedInItems : ", SelectedInTags);
    console.log("tempInTags : ", inTags);
    console.log("selectedNotInItems : ", SelectedNotInTags);
    console.log("tempNotInTags : ", notInTags);
    dispatch(updateSearchBody({ key: "Tags", value: inTags }));
    dispatch(updateSearchBody({ key: "ExcludedTags", value: notInTags }));
    dispatch(updateSearchBody({ key: "TagIn", value: inTagArray }));
    dispatch(updateSearchBody({ key: "TagsNotIn", value: notInTagsArray }));
  };

  return (
    <div className="section-box">
      <h3 className="section-heading">Member Tags</h3>
      <div>
        {typeof Tags != "undefined" ? (
          <FMSelectMultipleOptionItems
            labels={Tags}
            isSection={false}
            onChangeFunction={(
              event: React.ChangeEvent<HTMLInputElement>,
              inFlag: boolean
            ) => handleChange(event, inFlag)}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default FMMemberTags;
